<mat-tab-group dynamicHeight [selectedIndex]="selectedReportIndex">
  <mat-tab>
    <ng-template mat-tab-label>
      <a
        [routerLink]="['/reporting']"
        routerLinkActive
        #rla="routerLinkActive"
        class="reporting-link"
      >
        Audience & Content
      </a>
    </ng-template>
    <div class="embed-container">
      <iframe
        [src]="audienceContentUrl"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <a
        [routerLink]="['/reporting/tag-engagement']"
        routerLinkActive
        #rla="routerLinkActive"
        class="reporting-link"
      >
        Tag Engagement
      </a>
    </ng-template>
    <div class="embed-container">
      <iframe [src]="tagEngagementUrl" frameborder="0" allowfullscreen></iframe>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <a
        [routerLink]="['/reporting/top-managers-asset-class']"
        routerLinkActive
        #rla="routerLinkActive"
        class="reporting-link"
      >
        Top Managers by Asset Class
      </a>
    </ng-template>
    <div class="embed-container">
      <iframe [src]="topManagersUrl" frameborder="0" allowfullscreen></iframe>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <a
        [routerLink]="['/reporting/topic-tag-rates']"
        routerLinkActive
        #rla="routerLinkActive"
        class="reporting-link"
      >
        Topic Tag Rates
      </a>
    </ng-template>
    <ng-template matTabContent>
      <app-reporting-topic-tag-rates></app-reporting-topic-tag-rates>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <a
        [routerLink]="['/reporting/fund-of-funds']"
        routerLinkActive
        #rla="routerLinkActive"
        class="reporting-link"
      >
        Buy List
      </a>
    </ng-template>
    <div class="embed-container">
      <iframe [src]="fundOfFundsUrl" frameborder="0" allowfullscreen></iframe>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <a
        [routerLink]="['/reporting/email-activity']"
        routerLinkActive
        #rla="routerLinkActive"
        class="reporting-link"
      >
        Email Activity Summary
      </a>
    </ng-template>
    <div class="embed-container">
      <iframe [src]="emailActivityUrl" frameborder="0" allowfullscreen></iframe>
    </div>
  </mat-tab>
</mat-tab-group>
